import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock, faEye, faEyeSlash, faUser, faHome, faPhone } from '@fortawesome/free-solid-svg-icons';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import SreenShotSlider from '../component/slider/sliderSs'
// import { FaFacebookF, FaGoogle, FaTwitter } from 'react-icons/fa';
import Spinner from '../component/spinner/spinner';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode";
import { toast } from 'react-toastify';
import { Base_Url, registerapi } from '../config/config';
import { faFacebookF, faGoogle, faTwitter } from '@fortawesome/free-brands-svg-icons';
import CustomerSlider from '../component/cards/customersCard';
import ShippingRateCalculator from '../component/cards/priceEstimator';
import Footer from '../component/footer/footer';


const schema = z.object({
  email: z.string().email('Invalid email address').nonempty('Email is required'),
  password: z.string().min(8, 'Password must be at least 8 characters long').nonempty('Password is required'),
  phone: z.string().min(10, 'Phone must be at least 10 characters long').nonempty('Phone is required'),
  name: z.string().min(1, 'Name is required').nonempty('Name is required'),
  company: z.string().optional(),
});

const SignUpPage = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isshowPassword, setIsshowPassword] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: zodResolver(schema),
  });
  const onSubmit = (data) => {
    setIsSubmitting(true);
    // const name = data.name;
    if (isChecked === true) {
      axios.post(Base_Url + registerapi, {
        // axios.post ("http://192.168.1.36/backendci4/api/register",{
        name: data.name,
        email: data.email,
        phone: data.phone,
        password: data.password,
        address: "",
        company_name: data.company
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          setIsSubmitting(false);
          if (response.data.status === 'SUCCESS') {
            toast.success("Sign up successful!");
            // localStorage.setItem('userDataSignup', JSON.stringify(response.data));
            navigate('/updateKYc');
          }
          else {
            toast.error(response.data.message.phone || response.data.message.email || response.data.message.password || "An error occurred.");
          }
        })
        .catch(function (error) {
          setIsSubmitting(false);
          toast.error("Sign up Failed!");
        });

    }
    else {
      toast.error('Please accept over terms and condition')
      setIsSubmitting(false)
    }
  };
  const handleInputChange = (event) => {
    const { value, id } = event.target;

    if (['phone'].includes(id)) {
      const filteredValue = value.replace(/[^0-9]/g, '');
      event.target.value = filteredValue;
    }
    if (['name'].includes(id)) {
      const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
      event.target.value = filteredValue;
    }
  }

  const platforms = [
    { src: "/assets/images/shopify.png", alt: "Shopify", label: "Shopify" },
    { src: "/assets/images/instm_logo.jpg", alt: "Instamojo", label: "Instamojo" },
    { src: "/assets/images/unicommers.png", alt: "Unicommers", label: "Unicommers" },
    { src: "/assets/images/woo.svg", alt: "Woocommerce", label: "Woocommerce" },
    { src: "/assets/images/magento.svg", alt: "Magento", label: "Magento" },
    { src: "/assets/images/amazon.svg", alt: "Amazon", label: "Amazon" },
    { src: "/assets/images/prestashops.svg", alt: "PrestaShop", label: "PrestaShop" },
    { src: "/assets/images/ocart.svg", alt: "OpenCart", label: "OpenCart" }
  ]


  const services = [
    {
      title: "Express Parcel Services",
      description: "Get your urgent shipments delivered quickly and reliably.",
      icon: "📦",
      link: "/Express",
    },
    {
      title: "Ecommerce Shipping Solutions",
      description:
        "Streamline your online store's fulfillment process with our hassle-free shipping options.",
      icon: "🛒",
      link: "/Ecommerce",
    },
    {
      title: "Import & Export Shipping Management",
      description:
        "Navigate the complexities of international trade with our expert guidance.",
      icon: "🌍",
      link: "/ExportImp",
    },
    {
      title: "Less-than-Truckload (LTL)",
      description: "We offer cost-effective solutions for freight of all sizes.",
      icon: "🚛",
      link: "/Truckload",
    },
    {
      title: "Train Transport Services",
      description:
        "Benefit from the reliability and affordability of rail shipping for large shipments.",
      icon: "🚂",
      link: "/Traincargo",
    },
    {
      title: "Full-Truckload (FTL) Shipping",
      description: "We offer cost-effective solutions for freight of all sizes.",
      icon: "🚛",
      link: "/Truckload",
    },
  ];


  const partners = [
    { src: "/assets/images/Delhivery.png", alt: "Delhivery", label: "Delhivery" },
    { src: "/assets/images/ecom.png", alt: "ecom", label: "ecom" },
    { src: "/assets/images/bd.jpeg", alt: "bd", label: "bd" },
    { src: "/assets/images/xb.png", alt: "Xpressbess", label: "Xpressbess" },
    { src: "/assets/images/gati.jpg", alt: "Gati", label: "Gati" },
    { src: "/assets/images/sfx.png", alt: "Safexpress", label: "Safexpress" },
    { src: "/assets/images/ama.svg", alt: "AmazonShipping", label: "AmazonShipping" },
    { src: "/assets/images/spice.svg", alt: "Spicejet", label: "Spicejet" },
    { src: "/assets/images/dw.svg", alt: "Dpword", label: "Dpword" }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const itemsPerSlide = 5;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex + 1 >= partners.length ? 0 : prevIndex + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [partners.length]);


  const visiblePartners = () => {
    const result = [];
    for (let i = 0; i < itemsPerSlide; i++) {
      const index = (currentIndex + i) % partners.length;
      result.push(partners[index]);
    }
    return result;
  };


  return (
    <div>
      {/* <div style={{ backgroundImage: `url('/assets/images/texture.jpg')` }}
        className='-z-10 h-full w-full opacity-10 fixed top-0 left-0 pointer-events-none'>
      </div> */}
      <div className='relative z-10 grid grid-cols-1 md:grid-cols-3 gap-4 font-public-sans h-full'>
        <div className='col-span-1 md:col-span-2 flex flex-col justify-between mt-4 md:mt-24 ml-8'>
          <div className="m-2 md:m-0 md:p-2">
            <div className='flex flex-row gap-1 md:gap-2'>
              <h1 className='text-xl md:text-5xl font-bold font-open-sans text-gray-800'>
                SHIPPED MORE THAN
              </h1>
              <h1 className='text-xl md:text-5xl font-bold font-open-sans text-blueMain'>
                1 CRORE
              </h1>
            </div>
            <h1 className='text-xl md:text-5xl font-bold font-open-sans text-gray-800 mt-4'>
              PACKETS IN PREVIOUS QUARTER
            </h1>
            <p className='mt-4 text-base md:text-lg font-open-sans font-semibold'>
              We are the fastest-growing logistics company providing service in B2B & E-commerce segment.
              We have the best-in-class team, and our customer support team is working 24X7.
            </p>
            {/* <div className='w-full md:w-md h-auto md:h-92'>
              <img src='/assets/images/man.png' alt='Man' className='object-cover w-full h-full' />
            </div> */}
            <div className="relative w-full overflow-hidden rounded-lg">
              <div className="w-full md:w-[500px] h-auto md:h-[468px] mx-auto">
                <div className="absolute top-0 right-0 z-0 w-32 h-32 transform translate-x-1/2 -translate-y-1/2 rotate-45 bg-gradient-to-br from-blue-300/50 to-purple-400/50 animate-pulse rounded-lg"></div>

                <div className="absolute bottom-0 left-0 z-0 w-40 h-40 transform -translate-x-1/2 translate-y-1/2 -rotate-45 bg-gradient-to-tl from-green-300/50 to-cyan-400/50 animate-bounce-slow rounded-lg"></div>

                <video
                  className="absolute top-24 left-56 w-[420px] h-[320px] object-cover z-10"
                  autoPlay
                  loop
                  muted
                  playsInline
                >
                  <source src="/assets/video/couris-11339227.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                <div className="absolute top-0 left-0 w-full h-full z-20 pointer-events-none"></div>
              </div>
            </div>
            <style jsx>{`
  @keyframes bounce-slow {
    0%, 100% { transform: translateY(0) rotate(-45deg); }
    50% { transform: translateY(-20px) rotate(-45deg); }
  }
  
  .animate-bounce-slow {
    animation: bounce-slow 3s ease-in-out infinite;
  }
`}</style>

          </div>
          {/* Adding content similar to the image */}
          <div className="mt-8 mb-8 ml-2 md:ml-0">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="bg-amber-50 p-4 rounded-lg text-center">
                <h3 className="font-bold text-gray-700 text-2xl">Rs.30</h3>
                <p className="text-sm mt-2">Start with 30 rupees</p>
              </div>
              <div className="bg-amber-50 p-4 rounded-lg text-center">
                <h3 className="font-bold text-gray-700 text-2xl">NO</h3>
                <p className="text-sm mt-2">Minimum order Value</p>
              </div>
              <div className="bg-amber-50 p-4 rounded-lg text-center">
                <h3 className="font-bold text-gray-700 text-2xl">50%</h3>
                <p className="text-sm mt-2">lower rates on Heavy Parcels</p>
              </div>
              <div className="bg-amber-50 p-4 rounded-lg text-center">
                <h3 className="font-bold text-gray-700 text-2xl">FREE</h3>
                <p className="text-sm mt-2">COD Remittance</p>
              </div>
            </div>
          </div>
        </div>

        <div className='col-span-1 bg-gray-50 p-4 flex items-center justify-center mt-16'>
          <section className="w-full">
            <div className="text-center mb-2">
              <img className="mx-auto" src="/assets/images/logo1.png" width="170" height="150" alt="Logo" />
              <h5 className="text-xl font-sans" style={{ fontFamily: 'Open Sans, Public Sans, sans-serif' }}>Signup to PICKUPXPRESS</h5>
            </div>
            <div className="w-full max-w-md bg-white p-6 rounded-xl mb-10 border-gray-200 border font-public-sans shadow-lg">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="relative mb-5 font-public-sans">
                  <span className="absolute inset-y-0 left-0 flex pl-3 items-center">
                    <FontAwesomeIcon icon={faUser} className="text-gray-400" />
                  </span>
                  <input
                    type="text"
                    className={`w-full pl-10 pr-3 py-2 border ${errors.name ? 'border-red-500' : 'border-gray-300'} rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600 focus:shadow-md focus:shadow-purple-400 placeholder-gray-500 placeholder:text-sm font-public-sans`}
                    placeholder="Name"
                    id='name'
                    {...register('name')}
                    onChange={handleInputChange}
                  />
                  {errors.name && (
                    <p className="text-red-500 text-xs absolute top-full mt-0 left-0 w-full">
                      {errors.name.message}
                    </p>
                  )}
                </div>

                <div className="relative mb-5 font-public-sans">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                    <FontAwesomeIcon icon={faHome} className="text-gray-400" />
                  </span>
                  <input
                    type="text"
                    className={`w-full pl-10 pr-3 py-2 border ${errors.company ? 'border-red-500' : 'border-gray-300'} rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600 focus:shadow-md focus:shadow-purple-400 placeholder-gray-500 placeholder:text-sm font-public-sans`}
                    placeholder="Company name"
                    {...register('company')}
                  />
                </div>

                <div className="relative mb-5 font-public-sans">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                    <FontAwesomeIcon icon={faEnvelope} className="text-gray-400" />
                  </span>
                  <input
                    type="email"
                    className={`w-full pl-10 pr-3 py-2 border ${errors.email ? 'border-red-500' : 'border-gray-300'} rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600 focus:shadow-md focus:shadow-purple-400 placeholder-gray-500 placeholder:text-sm font-public-sans`}
                    placeholder="Email"
                    {...register('email')}
                  />
                  {errors.email && (
                    <p className="text-red-500 text-xs absolute top-full mt-0 left-0 w-full">
                      {errors.email.message}
                    </p>
                  )}
                </div>
                <div className="relative mb-5 font-public-sans">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                    <FontAwesomeIcon icon={faPhone} className="text-gray-400" />
                  </span>
                  <input
                    type="text"
                    maxLength="10"
                    id='phone'
                    className={`w-full pl-10 pr-3 py-2 border ${errors.phone ? 'border-red-500' : 'border-gray-300'} rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600 focus:shadow-md focus:shadow-purple-400 placeholder-gray-500 placeholder:text-sm font-public-sans`}
                    placeholder="Mobile no."
                    {...register('phone')}
                    onChange={handleInputChange}
                  />
                  {errors.phone && (
                    <p className="text-red-500 text-xs absolute top-full mt-0 left-0 w-full">
                      {errors.phone.message}
                    </p>
                  )}
                </div>

                <div className="relative mb-5 font-public-sans">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                    <FontAwesomeIcon icon={faLock} className="text-gray-400" />
                  </span>
                  <input
                    type={isshowPassword ? 'text' : 'password'}
                    className={`w-full pl-10 pr-3 py-2 border ${errors.password ? 'border-red-500' : 'border-gray-300'} rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600 focus:shadow-md focus:shadow-purple-400 placeholder-gray-500 placeholder:text-sm font-public-sans`}
                    placeholder="Password"
                    {...register('password')}
                  />
                  <span
                    className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
                    onClick={() => setIsshowPassword(!isshowPassword)}
                  >
                    <FontAwesomeIcon icon={isshowPassword ? faEye : faEyeSlash} className="text-gray-400" />
                  </span>
                  {errors.password && (
                    <p className="text-red-500 text-xs absolute top-full mt-0 left-0 w-full">
                      {errors.password.message}
                    </p>
                  )}
                </div>

                <div className="p-4 mx-auto">
                  <div className="flex items-start">
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={(e) => setIsChecked(e.target.checked)}
                      className="w-5 h-5 border-gray-300 rounded text-blue-600 focus:ring-blue-500"
                    />
                    <label htmlFor="acceptTerms" className="ml-3 text-gray-700 text-sm">
                      <span className="font-semibold">By creating a  Account, you agree to </span>{' '}
                      <a href="https://pickupxpress.com/Tandc" className="text-blue-600 hover:underline">
                        Pickupxpress's Terms & Conditions
                      </a>{' '}
                      and{' '}
                      <a href="https://pickupxpress.com/Privacypolicy" className="text-blue-600 hover:underline">
                        Privacy Policy
                      </a>.
                    </label>
                  </div>
                </div>
                <button
                  className="w-full bg-gray-800 text-white py-3 px-4 rounded-md hover:bg-gray-700 text-sm font-open-sans font-bold items-center justify-center flex"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? <Spinner /> : 'Create Account'}
                </button>

                {/* Login options section with divider */}
                <div className="text-center mt-6 text-sm text-gray-500">
                  <p>You can log in to your account using</p>
                  <div className="flex items-center justify-center my-4">
                    <div className="flex-1 border-t border-gray-300"></div>
                    <span className="px-3 text-gray-500 bg-white">OR</span>
                    <div className="flex-1 border-t border-gray-300"></div>
                  </div>

                  <div className="flex justify-center space-x-4 mt-4">
                    <button type="button" className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-600 text-white hover:bg-blue-700">
                      <FontAwesomeIcon icon={faFacebookF} size="lg" />
                    </button>
                    <button type="button" className="flex items-center justify-center w-12 h-12 rounded-full bg-red-600 text-white hover:bg-red-700">
                      <FontAwesomeIcon icon={faGoogle} size="lg" />
                    </button>
                    <button type="button" className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-400 text-white hover:bg-blue-500">
                      <FontAwesomeIcon icon={faTwitter} size="lg" />
                    </button>
                  </div>
                  <div className="mt-6 text-center">
                    <p className="text-gray-600">
                      Already have an account? <a href="/login" className="text-blue-600 hover:underline font-semibold">Log in</a>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </section>
        </div>
      </div>

      <div className="container mx-auto px-6">
        <div className="flex flex-col items-center">
          <h3 className="text-xl font-bold text-gray-800 mb-6">Forget to Download Order? Sync with Easy Integration process</h3>
          <p className="text-lg text-center mb-8 text-sky-700">
            Seamlessly integrate with major platforms like Shopify, WooCommerce,
            Magento, Instamojo, PrestaShop, UniCommerce, Amazon, OpenCart, and
            more.
          </p>
          {/* Icon Row: Left to Right, No Wrap */}
          <div className="w-full overflow-x-auto">
            <marquee class="marq py-2" direction="left" scrollamount="32" loop="">
              <div className="flex justify-between items-center gap-4 min-w-[600px] px-4">
                {platforms.map((partner, idx) => (
                  <div
                    key={idx}
                    className={`flex flex-col items-center w-24 rounded-md p-2 shadow-sm ${partner.label === "Woocommerce"
                      ? "bg-gray-300" // Light purple for WooCommerce
                      : partner.label === "OpenCart"
                        ? "bg-gray-300" // Light blue for Opencart
                        : "bg-white"
                      }`}
                  >
                    <img
                      src={partner.src}
                      alt={partner.alt}
                      className="h-12 w-20 object-contain mb-1"
                    />
                    <span className="text-xs font-medium text-center">{partner.label}</span>
                  </div>
                ))}
              </div>
            </marquee>
          </div>
        </div>
      </div>

      <div className="flex flex-col md:flex-row items-center justify-between  gap-6">
        <div className="md:w-1/3 flex justify-center mb-8">
          <img
            src="/assets/images/boxes.jpeg"
            alt="Shipping Boxes"
            className="w-96 object-contain"
          />
        </div>

        <div className="md:w-2/3 mt-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 ">
            <div className="bg-[#fffceb] p-6 rounded-lg text-center">
              <p className="text-sm text-[#3d4356]">Start with as low as</p>
              <h3 className="text-4xl font-bold text-[#3d4356] mt-2">Rs.30</h3>
            </div>

            <div className="bg-[#fffceb] p-6 rounded-lg text-center">
              <h3 className="text-4xl font-bold text-[#3d4356]">NO</h3>
              <p className="text-sm text-[#3d4356] mt-2">Minimum order Value</p>
            </div>

            <div className="bg-[#fffceb] p-6 rounded-lg text-center">
              <h3 className="text-4xl font-bold text-[#3d4356]">50%</h3>
              <p className="text-sm text-[#3d4356] mt-2">lower rates on Heavy Parcels</p>
            </div>

            <div className="bg-[#fffceb] p-6 rounded-lg text-center">
              <h3 className="text-4xl font-bold text-[#3d4356]">FREE</h3>
              <p className="text-sm text-[#3d4356] mt-2">2 Day COD Remittance</p>
            </div>


            <div className="bg-[#fffceb] p-6 rounded-lg text-center">
              <h3 className="text-4xl font-bold text-[#3d4356]">24/7</h3>
              <p className="text-sm text-[#3d4356] mt-2">Customer Support</p>
            </div>

            <div className="bg-[#fffceb] p-6 rounded-lg text-center">
              <h3 className="text-4xl font-bold text-[#3d4356]">PAN India</h3>
              <p className="text-sm text-[#3d4356] mt-2">Delivery Network</p>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full py-8 px-4 md:px-8">
        <div className="max-w-7xl  mx-auto">

          <h1 className="mt-12 text-3xl font-bold text-center mb-8">
            Domestic & International Shipping Solutions
          </h1>
          <p className="text-center mb-12">
            PickupXpress.com is your one-stop shop for all your shipping
            needs. We offer a comprehensive suite of services to ensure your
            parcels, ecommerce orders, and cargo reach their destinations
            efficiently and securely.
          </p>
          <div className="grid grid-cols-1  sm:grid-cols-2 md:grid-cols-3 gap-6 mt-12">
            {services.map((service, index) => (
              <a
                key={index}
                href={service.link}
                className="flex flex-col items-center text-center border p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
              >
                <div className="text-3xl mb-3">{service.icon}</div>
                <h3 className="font-semibold text-[#071a74f6] text-base mb-1">
                  {service.title}
                </h3>
                <p className="text-sm text-[#3d4356]">{service.description}</p>
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Partners Slider */}
      <div className="w-full py-12 px-4">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-10 text-sky-600">
            Our Partners
          </h2>
          <div className="relative overflow-hidden">
            <div className="flex items-center justify-center space-x-12">
              {visiblePartners().map((partner, index) => (
                <div key={index} className="flex flex-col items-center transition-all duration-500 ease-in-out">
                  <div className="h-32 w-48 flex items-center justify-center mb-2 bg-gray-50 p-2 rounded">
                    <img
                      src={partner.src}
                      alt={partner.alt}
                      className="max-h-full max-w-full object-contai  n"
                    />
                  </div>
                  <span className="text-sm text-gray-600">{partner.label}</span>
                </div>
              ))}
            </div>

            <div className="flex justify-center mt-6">
              {partners.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`h-2 w-2 mx-1 rounded-full ${index === currentIndex ? 'bg-blue-500' : 'bg-gray-300'
                    }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <CustomerSlider />
      <SreenShotSlider />
      <ShippingRateCalculator />
      <Footer />
    </div>
  );
};
export default SignUpPage;
